import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";

export const firebaseApi = createApi({
  reducerPath: "firebaseApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Recipe"],
  endpoints: (builder) => ({
    recipes: builder.query<Recipe[], void>({
      async queryFn() {
        try {
          const recipeRef = collection(db, "recipe_videos");
          const querySnaphot = await getDocs(recipeRef);
          const recipes: Recipe[] = [];
          querySnaphot?.forEach((doc) => {
            recipes.push({ id: doc.id, ...doc.data() } as Recipe);
          });
          return { data: recipes };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["Recipe"],
    }),
  }),
});

export const { useRecipesQuery } = firebaseApi;

export type Recipe = {
  id: string;
  bin_id: string;
  sku_image: string;
  sku_name: string;
  video_url: string;
  qr_url: string;
  sku_id: string;
};
